// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../data/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.content[data-v-7bddbfb2] {\n\tfont-size: 0.9em;\n}\n", ""]);
// Exports
module.exports = exports;
